import React from "react";
import type { IMatchDetails } from "../types/matchDetails.d";
import { getPlayerImageUrl } from "../../../../../../../helper/helper";
import { Images } from "../../../../../../../utils/imageConstants";

interface UpcomingMatchPlayersListProps {
  matchSummary?: IMatchDetails;
}

const UpcomingMatchPlayersList: React.FC<UpcomingMatchPlayersListProps> = ({ matchSummary }) => {
  const formatBatterStats = (batter: { matches: number; runs: number; average: number; strikeRate: number }) => {
    return `${batter.matches} M • ${batter.runs} Runs • ${(batter.average ?? 0).toFixed(2)} Avg • ${(batter.strikeRate ?? 0).toFixed(2)} SR`;
  };

  const formatBowlerStats = (bowler: { matches: number; wickets: number; economy: number; maiden: number }) => {
    return `${bowler.matches} M • ${bowler.wickets} Wkts • ${(bowler.economy ?? 0).toFixed(2)} Econ • ${bowler.maiden} Mdn`;
  };

  return (
    <div className="upcoming-players-list-container">
      <div className="upcoming-players-list-header">
        <div className="upcoming-players-list-header-item">
          <p>Batters to Watch (recent performance)</p>
        </div>
        <div className="upcoming-players-list-header-item">
          <p>Bowlers to Watch (recent performance)</p>
        </div>
      </div>
      <div className="upcoming-players-list-content">
        <div className="upcoming-players-list-column">
          {matchSummary?.topBatters?.map((batter, index) => (
            <div key={index} className="upcoming-players-list-item">
              <div className="player-info">
                <div className="player-image-wrapper">
                  <img src={getPlayerImageUrl(batter?.player?.image) || Images.player_profile_image} alt={batter.player?.playerFirstName} />
                </div>
                <div className="player-details">
                  <p className="player-name">{batter.player?.playerFirstName+" "+batter.player?.playerLastName || "-"}</p>
                  <p className="player-stats">{formatBatterStats(batter)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="upcoming-players-list-column">
          {matchSummary?.topBowlers?.map((bowler, index) => (
            <div key={index} className="upcoming-players-list-item">
              <div className="player-info">
                <div className="player-image-wrapper">
                  <img src={getPlayerImageUrl(bowler?.player?.image)||Images.player_profile_image } alt={bowler.player?.playerFirstName} />
                </div>
                <div className="player-details">
                  <p className="player-name">{bowler.player?.playerFirstName+" "+bowler.player?.playerLastName || "-"}</p>
                  <p className="player-stats">{formatBowlerStats(bowler)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpcomingMatchPlayersList;

